export class EmailNotificationDocument {
  collection: string;
  documentId: string;

  getCollection(): string {
    return this.collection;
  }

  setCollection(collection: string): EmailNotificationDocument {
    this.collection = collection;
    return this;
  }

  getDocumentId(): string {
    return this.collection;
  }

  setDocumentId(documentId: string): EmailNotificationDocument {
    this.documentId = documentId;
    return this;
  }
}
